/**
 * @member {string} about
 * @member {string} icon
 * @member {string} url
 */
export class FileDTO {
  constructor ({ about, icon, url }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }
    Object.defineProperty(this, 'about', Object.assign({ value: about }, properties));
    Object.defineProperty(this, 'icon', Object.assign({ value: icon }, properties));
    Object.defineProperty(this, 'url', Object.assign({ value: url }, properties));
    Object.freeze(this);
  }

  about;

  icon;

  url;
}
